import { render, staticRenderFns } from "./CadBloco.vue?vue&type=template&id=7cd3d8b8&"
import script from "./CadBloco.vue?vue&type=script&lang=js&"
export * from "./CadBloco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports